// extracted by mini-css-extract-plugin
module.exports = {"firstKV":"FirstKV_firstKV__62pZu","ef-box":"FirstKV_ef-box__LwG9J"};